import React from "react";

export default function Soporte() {
  const telefono = "573234266081";

  const abrirWhatsApp = () => {
    const mensaje = encodeURIComponent(
      "Hola, necesito soporte con la plataforma estudiantil."
    );
    const url = `https://wa.me/${telefono}?text=${mensaje}`;
    window.open(url, "_blank");
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Soporte</h2>

        <p style={styles.text}>
          ¿Tienes problemas con la plataforma? Nuestro equipo de soporte está listo para ayudarte.
        </p>

        <button style={styles.button} onClick={abrirWhatsApp}>
          Contactar por WhatsApp
        </button>

        <p style={styles.phone}>+57 323 426 6081</p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "80vh",
    backgroundColor: "#f4f6f9",
  },
  card: {
    backgroundColor: "#fff",
    padding: "30px",
    borderRadius: "12px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    textAlign: "center",
    maxWidth: "400px",
    width: "100%",
  },
  title: {
    marginBottom: "15px",
    color: "#333",
  },
  text: {
    marginBottom: "20px",
    color: "#666",
  },
  button: {
    backgroundColor: "#25D366",
    color: "#fff",
    border: "none",
    padding: "12px 20px",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "16px",
  },
  phone: {
    marginTop: "15px",
    color: "#999",
    fontSize: "14px",
  },
};
